<template>
  <div class="container">
    <r-process :dataArr="processData"></r-process>
    <el-card shadow="never" class="card">
      <span>Trans#: {{ bid }}</span>
    </el-card>
    <el-card shadow="never" header="BASIC INFORMATION" class="card">
      <customize-form-info
        ref="userInfoForm"
        :infoData="_basicInfoData"
        :isExtra="true"
      >
        <template v-slot:cosnameSlot v-if="basicInfoData.length">
          <span class="customerId" @click="goSnapShot(companydata)">
            {{ companydata.name }}
          </span>
        </template>
      </customize-form-info>
    </el-card>
    <el-card shadow="never" header="JAPAN" class="card" v-if="isJapan">
      <customize-form-info
        ref="japanInfoForm"
        :infoData="_japanInfo"
      ></customize-form-info>
    </el-card>
    <el-card
      class="card"
      shadow="never"
      header="RISK MITIGATION"
      v-if="this.auditStatus !== 5"
    >
      <customize-form-info
        v-for="(item1, index) in riskInfo1"
        :key="index"
        ref="riskInfoForm"
        :infoData="a(item1)"
      ></customize-form-info>
      <customize-form-info
        v-for="(item2, index) in riskInfo2"
        :key="index"
        ref="riskInfoForm"
        :infoData="a(item2)"
      ></customize-form-info>
    </el-card>
    <el-card
      class="card"
      shadow="never"
      header="RECENT CREDIT LINE"
      v-if="this.auditStatus !== 5"
    >
      <customize-form-info :infoData="_creditLineInfo"></customize-form-info>
    </el-card>
    <el-card
      class="card"
      shadow="never"
      header="REQUESTOR COMMENTS"
      v-if="this.auditStatus !== 5"
    >
      <html-content :content="content" />
      <customize-form
        :isShowForm="true"
        :schema="submitFormModel"
        ref="submitterComments"
      >
        <template v-slot:fileListSlot v-if="submitterFileList.length">
          <p
            class="fileItem"
            @click="fileClick(item)"
            v-for="(item, index) in submitterFileList"
            :key="index"
          >
            <i class="el-icon-document"></i>
            {{ item.name }}
          </p>
        </template>
      </customize-form>
    </el-card>
    <el-card
      class="card"
      shadow="never"
      header="CREDIT ANALYST COMMENTS"
      v-if="this.auditStatus !== 5"
    >
      <html-content :content="content1" />
      <customize-form
        :isShowForm="true"
        :schema="commentsModel"
        ref="analysisComments"
        :disabled="this.auditStatus === 3 || this.auditStatus === 4"
      >
        <template v-slot:fileListSlot v-if="anaFileList.length">
          <p
            class="fileItem"
            @click="fileClick(item)"
            v-for="(item, index) in anaFileList"
            :key="index"
          >
            <i class="el-icon-document"></i>
            {{ item.name }}
          </p>
        </template>
      </customize-form>
    </el-card>
    <el-card class="card" shadow="never" header="REQUEST DETAIL">
      <div v-if="$route.query.status?.toString() === '8'">
        <el-row>
          <el-col :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
            <span class="key">Credit Request Type：</span>
            <span class="value">
              {{ formData.requestType === 1 ? 'Line Of Credit' : 'Other' }}
            </span>
            <!--            <span class="value">
              <el-select v-model="formData.requestType" placeholder="请选择">
                <el-option label="Line Of Credit" :value="1"></el-option>
                <el-option label="Other" :value="2"></el-option>
              </el-select>
            </span>-->
          </el-col>
          <el-col :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
            <span class="key">Credit Type：</span>
            <span class="value">
              <el-select v-model="formData.type" placeholder="请选择">
                <el-option label="BAU" :value="1"></el-option>
                <el-option label="Uplift" :value="2"></el-option>
              </el-select>
            </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
            <span class="key">Request Amount($)：</span>
            <span class="value">
              <el-input
                style="width: 200px"
                v-model="formData.amount"
              ></el-input>
            </span>
          </el-col>
        </el-row>
      </div>
      <customize-form-info
        v-else
        :infoData="_requestDetailInfo"
      ></customize-form-info>
    </el-card>
    <el-card
      class="card"
      shadow="never"
      header="DECISIONS"
      v-if="this.auditStatus !== 5"
    >
      <el-row>
        <el-col :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          Credit Request Type：{{ creditInfo.requestType | requestType }}
        </el-col>
        <el-col :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          Credit Category：{{ creditInfo.approveType | approveType }}
        </el-col>
        <el-col :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          Approved Limit：{{ creditInfo.amount }}
        </el-col>
        <el-col :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          Partial Amount：{{ creditInfo.partialAmount }}
        </el-col>
        <el-col :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          Decision Type：{{ creditInfo.decisionType | decisionType }}
        </el-col>
        <el-col :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          Expire Date：{{ creditInfo.indateEnd }}
        </el-col>
        <el-col :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          Comments：
          <p
            style="margin-top: 14px; padding-left: 20px"
            v-html="decodeHtmlEntities(creditInfo.decisionComments)"
          ></p>
        </el-col>
      </el-row>
    </el-card>
    <el-card shadow="never" style="min-height: 200px">
      <p class="title">ADDITIONAL CONDITIONS</p>
      <template>
        <el-checkbox-group
          v-model="additionalChecked"
          @change="handleAddChange"
        >
          <el-checkbox
            v-for="condition in additionalConditionsCheckedVOList"
            :key="condition.id"
            :label="condition.id"
            style="display: block"
          >
            {{ condition.desc }}
          </el-checkbox>
        </el-checkbox-group>
      </template>
    </el-card>
    <div class="btnArea" v-if="[1, 2, 6, 8].includes(this.auditStatus)">
      <customize-button @click="handleDeclined">Declined</customize-button>

      <customize-button
        type="primary"
        @click="handleResubmit"
        v-if="additionalConditionsCheckedVOList.length"
        :class="isResubmit ? '' : 'btn-disabled'"
        :loading="isLoading"
      >
        Resubmit
      </customize-button>
      <customize-button
        type="primary"
        @click="handleResubmit"
        v-else
        :class="isResubmit ? 'btn-disabled' : ''"
        :loading="isLoading"
      >
        Resubmit
      </customize-button>
    </div>
  </div>
</template>

<script>
import mixins from '../mixins/mixins'
import RProcess from '../../../components/r-process/r-process'
import config from '@/config'
import { ERR_OK } from '@/utils/request'
import htmlContent from 'views/credit-management/credit-audit/html-content'
import _ from 'lodash'
import {
  getCssDetail,
  getCusInfo,
  getFile,
  secondSubmit,
  secondDeclined,
  getAddlog,
} from './api'

export default {
  name: 'credit-audit',
  mixins: [mixins],
  components: {
    RProcess,
    htmlContent,
  },
  computed: {
    _basicInfoData() {
      return [
        ...this.basicInfoData,
        ...this.outsideInfo,
        ...this.auditDetail,
        ...this.companyDetailInfo,
      ].map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        const filter = [
          'Total AR',
          'Valid Amount',
          'Average Overdue Ratio in last 12 mths(%)',
          'Overdue Amount >= 60 Days',
        ]
        if (filter.includes(item.key)) {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _japanInfo() {
      return this.japanInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        const filter = [
          'Latest Financial Year Total Profit',
          'Latest Financial Year Total Revenue',
          'Overdue Amount >= 60 Days',
          'Total Overdue AMT >= 60 Days',
          'Latest Financial Year Total Capital',
        ]
        if (filter.includes(item.key)) {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _riskInfo() {
      return this.riskInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        return item
      })
    },
    _creditLineInfo() {
      return this.creditLineInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        if (item.key === 'Credit Limit Amount') {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
    _requestDetailInfo() {
      return this.requestDetailInfo.map(item => {
        item.key = mixins.methods.transLabelToName(item.key)
        if (item.key === 'Request Amount($)') {
          item.value = this.$utils.formatAmount(item.value)
        }
        return item
      })
    },
  },
  filters: {
    requestType: function (value) {
      if (value === 1) {
        return 'Line Of Credit'
      } else if (value === 2) {
        return 'Other'
      }
      return ''
    },
    approveType: function (value) {
      if (value === 1) {
        return 'BAU'
      } else if (value === 2) {
        return 'Uplift'
      }
      return ''
    },
    decisionType: function (value) {
      console.log(value)
      if (value === 1) {
        return 'Manual Approved'
      } else if (value === 2) {
        return 'Declined'
      } else if (value === 3) {
        return 'Pending'
      } else if (value === 4) {
        return 'Conditional approval'
      } else if (value === 5) {
        return 'Cancelled'
      } else if (value === 8) {
        return 'Field Action'
      }
      return ''
    },
  },
  data() {
    const basicInfoKeys = [
      'code',
      'name',
      'businessStr',
      'regionStr',
      'countryStr',
      'paymentTermReq',
    ]
    const outerKeys = ['totalAR', 'totalBacklog', 'totalExposure']
    const companyDetailKeys = [
      'averageOverdueRatioLast12',
      'overdueAmount60',
      'paytrendOrAverageAging',
    ]
    const japanKeys = [
      'totalOverdueAmt60',
      'tdbRating',
      'latestFYTotalProfit',
      'latestFDate',
      'latestFYTotalRevenue',
      'latestFYTotalCapital',
    ]
    const riskKeys1 = ['collateralAmount', 'expirationDate', 'currency']
    const riskKeys2 = ['insuranceAmount', 'expirationDate', 'currency']
    const scoreKeys = [
      'sp',
      'moodysStr',
      'fitchStr',
      'frisk',
      'zscore',
      'zscoreSecond',
      'scoreCard',
      // 'globalCustomerRating',
      'theoreticalLimit',
    ]
    const submitFormModel = [
      // {
      //   key: 'submitterComment',
      //   label: '',
      //   type: 'textarea',
      //   value: '',
      //   readonly: true,
      //   disabled: true,
      // },
    ]
    const commentsModel = [
      // {
      //   key: 'creditAnalysisComment',
      //   label: '',
      //   type: 'textarea',
      //   readonly: true,
      //   rules: [
      //     {
      //       min: 0,
      //       max: 20000,
      //       message: 'No more than 20000 characters.',
      //       trigger: 'blur',
      //     },
      //   ],
      // },
    ]
    const otherKeys = ['requestTypeStr', 'applyTypeStr']
    const creditLineKeys = ['typeStr', 'indateEnd', 'amount', 'requestTypeStr']
    const decisionFormData = [] // 从上一页的decision form传过来的值，在第二次审批处回显
    return {
      uploadUrl: `${config.baseApi}/workflow-api/credit-apply/attachment/upload`,
      allInfo: {},
      basicInfoKeys,
      basicInfoData: [],
      outerKeys,
      bid: this.$route.query.bpmId,
      outsideInfo: [],
      auditDetail: [], // current credit line 字段
      companyDetailKeys,
      companyDetailInfo: [],
      isJapan: false, // 是否是日本公司
      japanInfo: [],
      japanKeys, // 日本公司数据info
      companydata: [],
      riskInfo: [], // risk info & keys
      scoreKeys,
      creditLineKeys,
      riskKeys1,
      riskKeys2,
      riskInfo1: [], // risk info & keys
      riskInfo2: [], // risk info & keys
      creditLineInfo: [], // credit line info & keys
      requestDetailInfo: [], // request detail info & keys
      submitFormModel,
      commentsModel,
      processData: [],
      anaFileList: [], // ana 上传文件列表
      decisionFileList: [], // decision 上传文件列表
      anaForm: { type: '' },
      submitterFileList: [], // submitter 文件列表
      auditStatus: 0,
      otherKeys,
      // 审核的状态，1-WQ(pending)(3btn)；2-Success(manualapp)(1btn-Update)；3-Reject&4-Cancel(0btn);5-AutoRules(0btn3info+submit&files)
      decisionTxtArea: '', // decision 的 textarea
      conditionTypeList: [], // addition conditions的下拉列表
      conditionNameList: [],
      conditionRes: [], // addition condition 的form表单数据(所有)
      decisionFormData,
      additionalChecked: [],
      additionalConditionsCheckedVOList: [],
      isResubmit: false,
      isReassignBtn: true,
      isResubmitBtn: true,
      isSaveBtn: true,
      isUpdateBtn: true,
      isUpdateDecisionBtn: true,
      isDeclined: true,
      isLoading: false,
      content: '',
      content1: '',
      formData: {
        requestType: '',
        type: '',
        amount: '',
      },
      creditInfo: {},
    }
  },
  mounted() {
    this.$storage.setItem('curBpmId', this.$route.query.bpmId)
    const auditParams = {
      bpmId: this.$route.query.bpmId || this.$storage.getItem('curBpmId'),
    }
    this._getCssDetail(auditParams)
    // 处理从上一页传过来的decision form数据(填写的)
    this._handleDecisionData(this.$route.query)
  },
  beforeDestroy() {
    this.timer = null
    clearTimeout(this.timer)
  },
  methods: {
    decodeHtmlEntities(encodedStr) {
      const textArea = document.createElement('textarea')
      textArea.innerHTML = encodedStr
      return textArea.value
    },
    a(item1) {
      return item1.map(item => ({
        key: mixins.methods.transLabelToName(item.key),
        value:
          item.key === 'collateralAmount' || item.key === 'insuranceAmount'
            ? this.$utils.formatAmount(item.value)
            : item.value,
      }))
    },
    async goSnapShot(data) {
      await this.$storage.setItem('customerInfo', {
        name: data.name,
        address: data.address,
        code: data.code,
        country: data.countryStr,
        city: data.city,
        state: data.state,
      })
      let routeUrl = this.$router.resolve({
        path: `/customer-management/${data.id}/info/snapshot`, // 对应路由
      })
      window.open(routeUrl.href, '_blank')
      const params = {
        companyId: data.id,
      }
      await getAddlog(params)
    },
    async _getCssDetail(params) {
      try {
        const res = await getCssDetail(params)
        this.creditInfo = res.creditInfo
        this.isReassignBtn = res.isReassignBtn
        this.isResubmitBtn = res.isResubmitBtn
        this.isSaveBtn = res.isSaveBtn
        this.isUpdateBtn = res.isUpdateBtn
        this.isUpdateDecisionBtn = res.isUpdateDecisionBtn
        this.isDeclined = res.isDeclined
        // ----- 获取此审核的status，赋值给this.auditStatus
        this.auditStatus = res.creditInfo.status
        if (
          res.creditInfo.creditAnalystComments.includes('&gt;') ||
          res.creditInfo.creditAnalystComments.includes('&lt;') ||
          res.creditInfo.creditAnalystComments.includes('\n')
        ) {
          res.creditInfo.creditAnalystComments =
            res.creditInfo.creditAnalystComments.replace(/&lt;/g, '<')
          res.creditInfo.creditAnalystComments =
            res.creditInfo.creditAnalystComments.replace(/&gt;/g, '>')
          res.creditInfo.creditAnalystComments =
            res.creditInfo.creditAnalystComments.replace(/\n/g, '<br/>')
        }
        this.content1 = res.creditInfo.creditAnalystComments
        // this.commentsModel = [
        //   {
        //     key: 'creditAnalysisComment',
        //     label: '',
        //     type: 'textarea',
        //     value: res.creditInfo.creditAnalystComments,
        //     rules: [
        //       {
        //         min: 0,
        //         max: 20000,
        //         message: 'No more than 20000 characters.',
        //         trigger: 'blur',
        //       },
        //     ],
        //   },
        // ]
        // 回显decision的textarea
        this.decisionTxtArea = res.creditInfo.decisionComments
        // ___ 将ana和decision的文件回显
        this.anaFileList = res.attachments
          .filter(item => item.fileType === 2)
          .map(item => ({
            name: item.fileName,
            url: item.url,
            id: item.id,
          }))
        this.decisionFileList = res.attachments
          .filter(item => item.fileType === 3)
          .map(item => ({
            name: item.fileName,
            url: item.url,
            id: item.id,
          }))
        // ---
        // 取出credit line的信息
        const _auditArr = []
        const obj = {}
        obj.key = 'validAmount'
        obj.value = res['validAmount']
        _auditArr.push(obj)
        this.auditDetail = _auditArr
        // 操作credit line 数据
        const _creditLine = []
        Object.keys(res.historyAmount).forEach(key => {
          if (this.creditLineKeys.indexOf(key) !== -1) {
            const obj = {}
            obj.key = key
            obj.value = res.historyAmount[key]
            _creditLine.push(obj)
          }
        })
        this.creditLineInfo = _creditLine
        // ___ 文件列表
        this.submitterFileList = res.attachments
          .filter(item => item.fileType === 1)
          .map(item => ({
            name: item.fileName,
            url: item.url,
            id: item.id,
          }))
        // ___
        // take request detail
        const _requestDetailInfo = []
        Object.keys(res.creditInfo).forEach(key => {
          if (res.creditInfo.requestType === 1) {
            if (
              key === 'amount' ||
              key === 'applyTypeStr' ||
              key === 'requestTypeStr'
            ) {
              const _obj = {
                key: key === 'amount' ? 'amountDetail' : key,
                value: res.creditInfo[key],
              }
              _requestDetailInfo.push(_obj)
            }
          } else {
            if (this.otherKeys.indexOf(key) !== -1) {
              const _obj = {}
              _obj.key = key
              _obj.value = res.creditInfo[key]
              _requestDetailInfo.push(_obj)
            }
          }
        })

        this.formData = _.pick(res.creditInfo, Object.keys(this.formData))

        this.requestDetailInfo = _requestDetailInfo
        // take process
        this.processData = res.process

        // 回显remark 进行特殊符处理
        if (
          res.creditInfo.remark.includes('&gt;') ||
          res.creditInfo.remark.includes('&lt;') ||
          res.creditInfo.remark.includes('\n')
        ) {
          res.creditInfo.remark = res.creditInfo.remark.replace(/&lt;/g, '<')
          res.creditInfo.remark = res.creditInfo.remark.replace(/&gt;/g, '>')
          res.creditInfo.remark = res.creditInfo.remark.replace(/\n/g, '<br/>')
        }
        this.content = res.creditInfo.remark
        // this.submitFormModel = [
        //   {
        //     ...this.submitFormModel[0],
        //     value: res.creditInfo.remark,
        //   },
        // ]
        // 请求工作流审批客户详情
        this._getCusInfo(res.creditInfo.companyId)
        // second additional conditions
        this.additionalConditionsCheckedVOList =
          res.additionalConditionsCheckedVOList
        this.additionalConditionsCheckedVOList.forEach(item => {
          if (item.desc.includes('&gt;') || item.desc.includes('&lt;')) {
            item.desc = item.desc.replace(/&gt;/g, '>')
            item.desc = item.desc.replace(/&lt;/g, '<')
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    async _getCusInfo(id) {
      try {
        const params = {
          id,
        }
        const res = await getCusInfo(params)
        this.companydata = res.companyInfoVO
        this.allInfo = res
        this.filterData(res)
      } catch (err) {
        console.log(err)
      }
    },
    //对数据进行摘取
    filterData(allData) {
      // 如果是日本
      if (allData.companyInfoVO.countryStr === 'Japan') {
        this.isJapan = true
        if (allData.companyJapanDetailVO) {
          const _japanInfo = []
          this.japanInfo = this.handleKeys(
            allData.companyJapanDetailVO,
            _japanInfo,
            this.japanKeys,
          )
        }
      }
      // 对外层数据进行操作，之后合并一起传给r-form
      const _outArr = []
      Object.keys(allData).forEach(key => {
        if (this.outerKeys.indexOf(key) !== -1) {
          const _obj = {}
          _obj.key = key
          _obj.value = allData[key]
          _outArr.push(_obj)
        }
      })
      this.outsideInfo = _outArr
      // 对 customer basic info操作
      if (allData.companyInfoVO) {
        const _basicInfoData = []
        this.basicInfoData = this.handleKeys(
          allData.companyInfoVO,
          _basicInfoData,
          this.basicInfoKeys,
        )
      }
      // 对company detail 数据进行操作
      if (allData.companyDetailVO) {
        const _companyDetailInfo = []
        this.companyDetailInfo = this.handleKeys(
          allData.companyDetailVO,
          _companyDetailInfo,
          this.companyDetailKeys,
        )
      }
      // 对risk数据进行操作
      if (allData.riskMitigationVO) {
        const InsurancesArr = allData.riskMitigationVO.companyInsurances
        const AssurancesArr = allData.riskMitigationVO.companyAssurances
        for (let item = 0; item < AssurancesArr.length; item++) {
          const _riskInfo1 = []
          this.riskInfo1.push(
            this.handleKeys(AssurancesArr[item], _riskInfo1, this.riskKeys1),
          )
        }
        for (let index = 0; index < InsurancesArr.length; index++) {
          const _riskInfo2 = []
          this.riskInfo2.push(
            this.handleKeys(InsurancesArr[index], _riskInfo2, this.riskKeys2),
          )
        }
      }
    },
    // 提出来function handle keys
    handleKeys(dataObj, targetArr, keysArr) {
      Object.keys(dataObj).forEach(key => {
        if (keysArr.indexOf(key) !== -1) {
          const obj = {}
          obj.key = key
          obj.value = dataObj[key]
          targetArr.push(obj)
        }
      })
      return targetArr
    },
    // 底部button事件
    async handleResubmit() {
      const params = {
        bpmId: this.$storage.getItem('curBpmId'),
        additionalConditionsCheckedBOList: this.additionalChecked.map(
          condition => ({
            checked: 1,
            id: condition,
          }),
        ),
        ...this.formData,
      }
      if (this.additionalConditionsCheckedVOList.length === 0) {
        this.isLoading = true
        try {
          await secondSubmit(params)
          this.timer = setTimeout(() => {
            this.isLoading = false
            this.$router.push('/work-queue')
          }, 2000)
        } catch (err) {
          console.error(err)
        }
      } else {
        if (this.isResubmit) {
          // 可以resubmit
          this.isLoading = true
          try {
            await secondSubmit(params)
            this.timer = setTimeout(() => {
              this.isLoading = false
              this.$router.push('/work-queue')
            }, 2000)
          } catch (err) {
            console.error(err)
          }
        }
      }
    },
    async handleDeclined() {
      try {
        await secondDeclined({ bpmId: this.$storage.getItem('curBpmId') })
        this.$message.success('success')
        this.$router.push('/credit-management/credit-request/query')
      } catch (err) {
        console.error(err)
      }
    },
    handleAnaChange(file, fileList) {
      if (!file.response) {
        this.anaFileList.splice(0, 1, file)
      }
      this.anaFileList = fileList
    },
    anaUploadSuccess({ code, msg }) {
      if (code === ERR_OK) {
        this.$message.success('success')
      } else {
        this.$message.error(msg)
        this.anaFileList.pop()
      }
    },
    handleDecisionChange(file, fileList) {
      // 单个文件上传
      if (!file.response) {
        this.decisionFileList.splice(0, 1, file)
      }
      this.decisionFileList = fileList
    },
    decisionUploadSuccess({ code, msg }) {
      if (code === ERR_OK) {
        this.$message.success('success')
      } else {
        this.$message.error(msg)
        this.decisionFileList.pop()
      }
    },
    async fileClick(fileList) {
      try {
        const params = {
          id: fileList.id,
        }
        await getFile(params)
      } catch (err) {
        console.log(err)
      }
    },
    // 处理decision form 数据
    _handleDecisionData(data) {
      delete data.bpmId
      delete data.source
      const _decisionFormData = []
      Object.keys(data).forEach(key => {
        if (key !== 'status') {
          _decisionFormData.push({
            key: key,
            value: data[key],
          })
        }
      })
      this.decisionFormData = this.transName(_decisionFormData)
    },
    transName(data) {
      const _temp = []
      data.forEach(obj => {
        if (obj.key === 'requestType') {
          if (obj.value === 1) {
            obj.value = 'Line Of Credit'
          } else {
            obj.value = 'Other'
          }
        }
        if (obj.key === 'approveType') {
          if (obj.value === 1) {
            obj.value = 'BAU'
          } else if (obj.value === 2) {
            obj.value = 'Uplift'
          } else {
            obj.value = 'Extension'
          }
        }
        if (obj.key === 'decisionType') {
          if (obj.value === 1) {
            obj.value = 'Manual Approved'
          } else if (obj.value === 2) {
            obj.value = 'Cancelled'
          } else if (obj.value === 3) {
            obj.value = 'Pending'
          } else {
            obj.value = 'Conditional Approval'
          }
        }
        _temp.push(obj)
      })
      return _temp
    },
    handleAddChange(value) {
      if (value.length === this.additionalConditionsCheckedVOList.length) {
        this.isResubmit = true
        return
      }
      this.isResubmit = false
    },
  },
}
</script>

<style scoped lang="less">
.container {
  width: 100%;
  .customerId {
    color: blue;
    font-size: 14px;
    cursor: pointer;
  }
  .card {
    width: 100%;
    margin-bottom: 24px;
  }
  .title {
    font-size: 16px;
    color: #3a3f63;
    font-weight: bold;
    margin-bottom: 24px;
  }
  .fileItem {
    height: 30px;
    width: 700px;
    font-size: 14px;
    cursor: pointer;
  }
  .fileItem:hover {
    color: #409eff;
  }
  .con-select {
    width: 380px;
    margin-bottom: 20px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 20px;
    margin-top: 40px;
  }

  .processBox {
    width: 100%;
    height: 190px;
    background-color: yellowgreen;
  }
}

.upload {
  width: 100%;
  margin-top: 20px;
  border-radius: 27px;
}

.txtArea {
  width: 700px;
  margin-top: 24px;
}

.btnArea {
  width: 100%;
  display: flex;
  margin-top: 24px;
  justify-content: center;
  button {
    margin-right: 24px;
  }
  .btn-disabled {
    cursor: not-allowed;
  }
}

.el-col {
  margin-bottom: 14px;
}
</style>
